import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\UpdateSettingKeysController::__invoke
* @see app/Http/Controllers/Settings/UpdateSettingKeysController.php
* @route '/api/settings/change-settings-key/{settingName}'
*/
const UpdateSettingKeysController = (args: { settingName: string | number } | [settingName: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSettingKeysController.url(args, options),
    method: 'put',
})

UpdateSettingKeysController.definition = {
    methods: ["put"],
    url: '/api/settings/change-settings-key/{settingName}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Settings\UpdateSettingKeysController::__invoke
* @see app/Http/Controllers/Settings/UpdateSettingKeysController.php
* @route '/api/settings/change-settings-key/{settingName}'
*/
UpdateSettingKeysController.url = (args: { settingName: string | number } | [settingName: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { settingName: args }
    }

    if (Array.isArray(args)) {
        args = {
            settingName: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        settingName: args.settingName,
    }

    return UpdateSettingKeysController.definition.url
            .replace('{settingName}', parsedArgs.settingName.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\UpdateSettingKeysController::__invoke
* @see app/Http/Controllers/Settings/UpdateSettingKeysController.php
* @route '/api/settings/change-settings-key/{settingName}'
*/
UpdateSettingKeysController.put = (args: { settingName: string | number } | [settingName: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSettingKeysController.url(args, options),
    method: 'put',
})

export default UpdateSettingKeysController